'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


// WEBPACK FOOTER //
// ./~/react-router-dom/~/history/ExecutionEnvironment.js